export const data = {
  rows: [
    {
      entity_id: '1492116',
      client_address_id: '1717670',
      entity_type: 'PICKUP',
      ce_team_action: 'APPROVE',
      floor_number: '1'
    },
    {
      entity_id: '1492117',
      client_address_id: '1717671',
      entity_type: 'DRS',
      ce_team_action: 'REJECT',
      floor_number: '2'
    }
  ],
  headers: [
    { key: 'entity_id', Header: 'entity_id' },
    { key: 'client_address_id', Header: 'client_address_id' },
    { key: 'entity_type', Header: 'entity_type' },
    { key: 'ce_team_action', Header: 'ce_team_action' },
    { key: 'floor_number', Header: 'floor_number' }
  ]
};
